import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { AudienceCancellationsComponent } from './components/audience-cancellations/audience-cancellations.component';
import { AudienceOnboardComponent } from './components/audience-onboard/audience-onboard.component';
import { AudienceOnboardService } from "./services/audience-onboard.service";

@NgModule({
    declarations: [
        AudienceOnboardComponent,
        AudienceCancellationsComponent,
    ],
    imports: [
        CommonModule,
        MatIconModule,
        AccountSharedModule,
    ],
    providers: [
        AudienceOnboardService
    ],
    exports: [
        AudienceOnboardComponent,
        AudienceCancellationsComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AudienceOnboardModule {
}
